// extracted by mini-css-extract-plugin
export var localeSelector = "_aq-0";